<template>
  <div style="margin: 30px">
    <div style="margin-bottom: 15px">
      <font-awesome-icon
        icon="angle-right"
        class="navIcon"
        size="2x"
        :class="[afterThisWeek ? '' : 'hideIcon']"
        @click="addWeek(-1)"
      />
      <span class="dateRange">{{ currentWeekString }}</span>

      <font-awesome-icon
        icon="angle-left"
        class="navIcon"
        size="2x"
        @click="addWeek(1)"
      />
    </div>
    <div class="top-side">
      <div class="right-side">
        <div class="menuItem" style="position: relative; top: 25px">
          انتخاب غذاخوری
        </div>
      </div>
      <div class="left-side">
        <div class="menuItem">
          <v-select
            :items="places"
            item-text="name"
            item-value="id"
            v-model="deliveryPlaceId"
            class="menuInput"
          ></v-select>
        </div>
      </div>
    </div>
    <div>
      <v-expansion-panels accordion focusable multiple v-model="panel">
        <v-expansion-panel v-for="(item, i) in 7" :key="i">
          <v-expansion-panel-header>
            <span style="color: #00a851"
              ><b style="font-size: 18px">{{ weekdayGenerator(item - 1) }}</b>
              {{ dateGenerator(item - 1) }}</span
            >
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div
              class="menuBorder"
              v-if="Object.keys(mealMenus[i]).length !== 0"
            >
              <div
                v-for="(meal, index) in meals"
                :key="meal.id"
                class="text-center"
              >
                <template v-if="mealMenus[i][meal.id.toString()]">
                  <div
                    class="trapezoid"
                    :style="'border-bottom: 32px solid #' + getColor(index)"
                  >
                    <span>
                      {{ meal.name }}
                    </span>
                  </div>
                  <hr :style="'color: #' + getColor(index)" />

                  <div
                    v-for="(menu, index) in mealMenus[item - 1][
                      meal.id.toString()
                    ]"
                    :key="menu.id"
                    class="startMenu"
                  >
                    <div class="top-side" style="margin-bottom: 50px">
                      <div class="right-side">
                        <div class="menuName">
                          <b>{{ menu.food.name }}</b>
                        </div>
                        <div style="font-size: 14px">
                          {{ menu.food.description }}
                        </div>
                        <div>قیمت: {{ menu.menuPrices[0].price }} ریال</div>
                      </div>
                      <div class="left-side">
                        <img
                          v-if="menu.food.fileKey != ''"
                          download
                          :src="downloadUrl(menu.food.fileKey)"
                          class="imageClass"
                        />
                      </div>
                    </div>
                    <div class="top-side actions" style="margin-bottom: 20px">
                      <div class="right-side">
                        <template v-if="!canReserve(item - 1, meal.id)">
                        </template>
                        <template v-else-if="menu.orders.length > 0">
                          <span
                            style="
                              position: relative;
                              top: 5px;
                              font-size: 14px;
                            "
                          >
                            تعداد سفارش شما:
                            {{ menu.orders[0].numberOrder }}
                          </span>
                        </template>

                        <template v-else>
                          <span style="font-size: 14px; margin-left: 5px"
                            >تعداد</span
                          >
                          <app-minusplusfield
                            :min="0"
                            :max="menu.menuPrices[0].tedadMojazSefaresh"
                            :value="menu.numberOfOrders"
                            v-model="menu.numberOfOrders"
                            :key="componentKey"
                          ></app-minusplusfield>
                        </template>
                      </div>
                      <div class="left-side">
                        <template v-if="!canReserve(item - 1, meal.id)">
                          <v-card-text
                            style="padding: 0px 0 0 0; text-align: center"
                            >اتمام یافته</v-card-text
                          >
                        </template>
                        <template v-else-if="menu.orders.length > 0">
                          <v-btn
                            color="green white--text"
                            style="width: 90%; margin: 0"
                            @click="cancelRequest(menu.orders[0].id)"
                            :disabled="apiRunning"
                          >
                            لغو
                          </v-btn>
                        </template>

                        <template v-else>
                          <v-btn
                            color="green white--text"
                            style="width: 90%; margin: 0"
                            @click="
                              applyRequest(
                                mealMenus[item - 1][meal.id.toString()][index]
                              )
                            "
                            :disabled="apiRunning || menu.numberOfOrders == 0"
                          >
                            رزرو
                          </v-btn>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Dialog from "@/components/Dialog";
import PlusMinusField from "@/components/PlusMinusField";
import { GetMenuWithOrders, SaveOrder, Cancel } from "@/api/orders";
import { GetBranchActiveMeals } from "@/api/meals";
import moment from "moment-jalaali";
import { GetBranchDeliveryPlace } from "@/api/deliveryplace";
export default {
  components: {
    appDialog: Dialog,
    appMinusplusfield: PlusMinusField,
  },
  data() {
    return {
      showMenuDialog: false,

      menus: [],
      meals: [],
      places: [],
      menuDate: moment().startOf("week"),
      deliveryPlaceId: 0,
      mealMenus: [{}, {}, {}, {}, {}, {}, {}],
      componentKey: 0,
      panel: [0, 1, 2, 3, 4, 5, 6],
    };
  },
  created() {
    if (this.currentRole) {
      this.GetBranchActiveMeals();

      this.GetBranchDeliveryPlace();
    }
  },
  computed: {
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentRole() {
      return this.$store.getters.currentRole;
    },

    currentWeekString() {
      return (
        this.menuDate.format("dddd jYYYY/jMM/jDD") + " تا " + this.endOfWeek
      );
    },
    startOfWeek() {
      return this.menuDate.format("jYYYY/jMM/jDD");
    },
    endOfWeek() {
      return moment(this.menuDate).endOf("week").format("dddd jYYYY/jMM/jDD");
    },
    afterThisWeek() {
      return (
        this.startOfWeek > moment().startOf("week").format("jYYYY/jMM/jDD")
      );
    },
  },

  methods: {
    canReserve(offset, id) {
      const currentDate = moment(new Date()).format("jYYYY/jMM/jDD");
      const date = moment(this.menuDate)
        .add(offset, "days")
        .format("jYYYY/jMM/jDD");
      if (date < currentDate) return false;
      else if (date > currentDate) return true;
      const currentTime = moment(new Date()).format("HH:mm:ss");

      for (let i = 0; i < this.meals.length; i++) {
        if (this.meals[i].id == id)
          return this.meals[i].startTime > currentTime;
      }
    },
    addWeek(index) {
      this.menuDate = moment(this.menuDate).add(index, "weeks");
      this.GetMenuWithOrders();
    },

    dateGenerator(offset) {
      return moment(this.menuDate).add(offset, "days").format("jD jMMMM");
    },
    weekdayGenerator(offset) {
      return moment(this.menuDate).add(offset, "days").format("dddd");
    },
    GetBranchDeliveryPlace() {
      return new Promise((resolve, reject) => {
        GetBranchDeliveryPlace(this.currentRole.BranchID)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.places = response.data.items;
            if (this.places.length == 1)
              this.deliveryPlaceId = this.places[0].id;

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetBranchActiveMeals() {
      return new Promise((resolve, reject) => {
        GetBranchActiveMeals(this.currentRole.BranchID)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.meals = response.data.items;
            this.GetMenuWithOrders();
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetMenuWithOrders() {
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetMenuWithOrders(
          this.currentRole.BranchID,
          this.currentRole.KPrice,
          this.startOfWeek,
          this.endOfWeek,
          0
        )
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.menus = response.data.items;

            this.generateMenus();
            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getColor(index) {
      let color = "006cb7";
      switch (index) {
        case 0:
          color = "C41E3A";

          break;
        case 1:
          color = "f68121";
          break;
      }

      return color;
    },
    findMenus(mealId, offset) {
      const tarikh = moment(this.menuDate)
        .add(offset, "days")
        .format("jYYYY/jMM/jDD");

      let result = [];

      for (const menu of this.menus) {
        if (menu.mealId == mealId && menu.tarikh == tarikh) {
          if (!menu["numberOfOrders"] && menu.orders.length == 0)
            menu["numberOfOrders"] = 1;
          result.push(menu);
        }
      }
      return result;
    },
    generateMenus() {
      this.mealMenus = [{}, {}, {}, {}, {}, {}, {}];
      this.meals.forEach((meal) => {
        for (let offset = 0; offset < 7; offset++) {
          const menus = this.findMenus(meal.id, offset);
          if (menus.length > 0)
            this.mealMenus[offset][meal.id.toString()] = menus;
        }
      });
      this.componentKey += 1;
    },
    downloadUrl(key) {
      return process.env.VUE_APP_API_ENDPOINT + "/api/File/GetFile?Key=" + key;
    },

    applyRequest(element) {
      var text = "";
      let filledMeal = [];

      if (element.numberOfOrders && element.numberOfOrders > 0) {
        filledMeal.push(element);
      }

      if (filledMeal.length == 0) {
        text = "حداقل یک غذا انتخاب شود.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        let orders = [];
        filledMeal.forEach((element) => {
          orders.push({
            Count: element.numberOfOrders,
            MenuPriceID: element.menuPrices[0].id,
          });
        });

        SaveOrder(this.currentRole.KPrice, this.deliveryPlaceId, orders, 0)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);
            this.$store.commit("SET_API_RUNNING", false);
            this.showMenuDialog = false;
            this.GetMenuWithOrders();
          })
          .catch((error) => {
            this.$store.commit("SET_API_RUNNING", false);
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
    cancelRequest(orderid) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", orderid);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به لغو این سفارش هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    onCloseDialog(index) {
      if (index != -1) {
        Cancel(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);

            if (data.success) {
              this.GetMenuWithOrders();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
      this.showMenuDialog = false;
    },
  },
};
</script>
<style scoped>
.navIcon {
  position: relative;
  top: 5px;
  cursor: pointer;
}
.dateRange {
  width: 260px;
  display: inline-block;
  text-align: center;
}
.v-data-table th {
  color: black !important;
}

.menuBorder {
  border: 1px solid #f0f0f0;
  padding: 15px 10px 0;
  border-radius: 5px;
  margin: 10px 0;
}

.menuHolder {
  text-align: right;
  display: block;
  overflow: auto;
  padding: 10px 0;
}
.menuItem {
  margin: 0 10px 10px 10px;
}
.menuDetail {
  width: 50px;
}

.right-side {
  float: right;
  width: 50%;
  margin-top: 2px;
  text-align: right;
}
.left-side {
  width: 50%;
  float: left;
  text-align: left;
}

.menuBorder .right-side {
  width: calc(100% - 150px);
  padding-right: 10px;
}

.menuBorder .left-side {
  width: 140px;
  max-width: 50%;
}

.actions .right-side {
  min-width: calc(100% - 140px);
  width: 68%;
  padding-right: 10px;
}

.actions .left-side {
  width: 140px;
  max-width: 30%;
  float: left;
}

.top-side {
  display: block;
  overflow: hidden;
}

.startMenu {
  padding: 15px 5px;
}

.bottom-side {
  display: block;
  overflow: hidden;
  text-align: left;
}
.menuInput {
  width: 100%;
}

.menuButton {
  width: 40%;
  max-width: 100px;
  margin: 10px 15px 0 0;
  border-style: solid;
  border-width: 1px;
  border-color: gray !important;
}
.imageClass {
  width: 90%;
}

hr {
  position: relative;
  margin-right: 102px;
  top: -1.5px;
}
</style>
<style>
.hideIcon {
  visibility: hidden;
}
.foodsDialog {
  max-width: 640px;
  padding: 10px 20px 30px;
  margin: 0 30px;
  background-color: white;
}
.v-expansion-panel-header::before {
  background-color: white !important;
}

.v-expansion-panel-header {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  transform-origin: unset;
}

.v-expansion-panel-header > span {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  text-align: right;
  font-size: 14px;
}
.trapezoid {
  border-left: 32px solid transparent;
  border-right: 0px solid transparent;
  height: 0;
  width: 104px;
  /* text-align: right; */
}

.trapezoid > span {
  font-size: 16px;
  color: white;
  font-weight: bold;
  top: 3px;
  position: relative;
  /*right: 16px;*/
}

.menuName {
  font-size: 18px;
  font-weight: bolder;
  color: purple;
  margin-bottom: 10px;
}

.v-expansion-panel-content__wrap {
  padding: 0 24px 0 !important;
}
</style>
